import React from 'react';
import { Header } from './components/Header';
import { VideoPlayer } from './components/VideoPlayer';
import { StatsSection } from './components/StatsSection';
import { HeroHighlight, Highlight } from './components/ui/HeroHighlight';
import { CalendlyEmbed } from './components/CalendlyEmbed';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { LogoMarquee } from './components/LogoMarquee';
const logos = [{
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dp2V9t4KBqtNRKwEZ16zWE/Premier-Roofing-Logo-800.webp',
  alt: 'Premier Roofing Company'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mz7NLRgHxHC3R8RzF3YCkX/TypeformVideoAsk_Transparent.png',
  alt: 'Typeform VideoAsk'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mWRbtmgL6tZDZ35pDz81aY/ChiprLogo__1_.png',
  alt: 'Chipr'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qPbuvohPjZaBcU1aJP17AB/GHL_Logo_512x512_px.png',
  alt: 'GoHighLevel'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/czCVSeeqm1K8BeLBVx28SK/Typeform_Cover_280x100_px.png',
  alt: 'Typeform'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/84u9Gp2QPa7E6EJEpaZ3NU/ME.Typeform_Transparent.png',
  alt: 'Median Energy'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5rxA7Dx3FrGrd5EKoo7eMc/GHL_Logo_512x512_px_%285%29.png',
  alt: 'NTY Windows'
}, {
  src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2FvmcCdQfLDAms5XrgWX9z/Freedom_WISP.jpg',
  alt: 'Freedom WISP'
}];
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <HeroHighlight data-id="element-1">
        <Header data-id="element-2" />
        <main className="max-w-6xl mx-auto px-4" data-id="element-3">
          <div id="headline" data-id="element-4">
            <p className="text-center text-sm sm:text-lg mb-2 mt-4 text-gray-900" data-id="element-5">
              For D2D & Direct Sales Teams ONLY...
            </p>
            <h1 className="text-center text-2xl sm:text-4xl md:text-5xl font-black mb-6 sm:mb-8 max-w-4xl mx-auto leading-[1.4] sm:leading-[1.3] text-gray-900" data-id="element-6">
              We Recruit Trained, Commission Ready Sales Reps Into Your D2D
              Business <Highlight className="px-1" data-id="element-7">Every Month</Highlight> On{' '}
              <Highlight className="px-1" data-id="element-8">Autopilot</Highlight>
            </h1>
            <div className="mb-10 sm:mb-12" data-id="element-9">
              <p className="text-center text-base sm:text-xl mb-4 sm:mb-6 text-gray-900" data-id="element-10">
                <strong data-id="element-11">Step 1: Tap play on the video below</strong> to learn
                how to add millions in profit to your business
              </p>
              <VideoPlayer data-id="element-12" />
            </div>
          </div>
          <div id="calendly" className="text-center mb-6" data-id="element-13">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-2 text-gray-900" data-id="element-14">
              Step 2: Fill out the short application and{' '}
              <Highlight data-id="element-15">book a call</Highlight>
            </h2>
            <p className="text-base sm:text-xl text-gray-600 mb-2" data-id="element-16">
              Application May Take a Few Moments to Load
            </p>
          </div>
          <CalendlyEmbed data-id="element-17" />
          <LogoMarquee logos={logos} data-id="element-18" />
          <div id="stats" data-id="element-19">
            <StatsSection data-id="element-20" />
          </div>
          <div id="faq" data-id="element-21">
            <FAQSection data-id="element-22" />
          </div>
          <Footer data-id="element-23" />
        </main>
      </HeroHighlight>
    </div>;
}